// Domains
export const DOMAIN = process.env.domain || 'asda.com'
export const HTTPS = 'https://'
export const HTTP = 'http://'
export const GHS_DOMAIN = `groceries.${DOMAIN}`
export const GEORGE_URL = document.domain === 'www.asda.com' ? 'https://direct.asda.com/george' : 'http://development-direct.asda.com/'
export const GHS_URL = `${HTTPS}${document.domain &&
  document.domain.replace('www', 'groceries')}`
export const GEORGE_NEEDHELP_URL = 'https://asda.custhelp.com/'
export const GROCERIES_NEEDHELP_URL = 'http://asda-grocery.custhelp.com/'
export const GEORGE_TERMSCONDITIONS_URL = 'https://direct.asda.com/george/GRG_INFO_TERMS_CONDITIONS,default,pg.html'
export const GROCERIES_TERMSCONDITIONS_URL = 'https://groceries.asda.com/terms-and-conditions'
export const GIFTCARDS_TERMSCONDITIONS_URL = 'https://www.asdagiftcards.com/terms-and-conditions'
export const GIFTCARDS_ACCOUNT_URL = document.domain === 'www.asda.com' ? 'https://www.asdagiftcards.com/account' : 'https://asda-gift-card.stickeedev.com/account'
export const GEORGE_PRIVACYPOLICY_URL = 'https://www.asda.com/privacy/your-information/customer-information/online/asda-george-com'
export const GROCERIES_PRIVACYPOLICY_URL = 'https://www.asda.com/privacy'
export const GEORGE_CONTACTUS_URL = 'https://asda.custhelp.com/'
export const GROCERIES_CONTACTUS_URL = 'https://www.asda.com/help/company-details'
export const GEORGE_REWARD_URL = 'https://direct.asda.com/on/demandware.store/Sites-ASDA-Site/default/GeorgeRewards-Show'
export const DOT_COM_URL = `${HTTPS}${document.domain}`
export const BABY_CLUB_URL = `${HTTPS}${document.domain}/baby-club`
export const GEORGE_ACCOUNT_URL = window.location.hostname === 'www.asda.com' ? 'https://direct.asda.com/on/demandware.store/Sites-ASDA-Site/default/Account-Start' : 'https://development-direct.asda.com/on/demandware.store/Sites-ASDA-Site/default/Account-Start'
export const GONE_FISHING_URL = `${GHS_URL}/asdaNS/gone_fishing.htm`
export const WAITING_PAGE_URL = `${GHS_URL}/waiting/waiting_page.htm`
export const BABY_CLUB_TNC_URL = 'https://www.asda.com/baby-club/terms'
